export const descriptions = {
	lockHomepage: 'A PIN must be entered to return to the homepage after a student completes self-assessment.',
	testResultVerbiage: 'Test Results verbiage appears on Parent Letters, Reports, and homepage pie charts.',
	testButtonLabels: 'Label buttons to indicate if the student answers the question correctly.',
	selfAssessmentAdministration:
		'Some tests offer a self-assessment version for students. When enabled, you can select ' +
		'which version of the test you want to provide.',
};
